import React, { useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { fetchdata, AddNeedsData, NeedsEditData, DeleteData } from '../reduxactions/adminrsactions/AdNeedsActions';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Message } from 'primereact/message';

import { AnyCnameRecord } from 'dns';
import { GFNButton } from '../ui';
export const AdminNeeds = () => {

  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('');

  const data = useSelector((state: RootState) => state.adneedsist.data);
  const adddata = useSelector((state: RootState) => state.adneedsist.adddata);
  const editdata = useSelector((state: RootState) => state.adneedsist.editdata);
  const deletedata = useSelector((state: RootState) => state.adneedsist.deletedata);
  const toast = useRef(adddata);
  const toast1 = useRef(editdata);
  const toast2 = useRef(deletedata);

  const dispatch = useDispatch()

  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  // To get data
  useEffectOnce(() => {
    fetchDataAsync();
  }, [dispatch]);
  const [Needsadd, setAddNeeds] = useState(false);
  const [needtype, setneedtype] = useState<any>(null);
  const [Needsedit, setNeedsEdit] = useState(false);

  const AddNeedsclose = async () => {
    setAddNeeds(false);
    setDeleteConfirmation(false);


  }
  //To add Needs dispatching data to ts
  const AddNeeds = async () => {
    await dispatch(AddNeedsData(needtype) as any);
    toast.current.show({ severity: 'success', summary: 'Added Successfully', detail: adddata, life: 3000 })
    setAddNeeds(false);
    fetchDataAsync();
    setneedtype(null)

  };
  const [editData, setEditData] = useState({
    needtype: '',
    id: '',
  });

  const Editdata = (rowData: any) => {
    setEditData({
      needtype: rowData.needtype,
      id: rowData.Id,
    });
    setNeedsEdit(true);
  }

  //To dispatch edit data fieldofficer.ts
  const EditAdminNeeds = async () => {
    const { id, needtype } = editData;
    await dispatch(NeedsEditData(needtype, parseInt(id, 10)) as any);
    toast1.current.show({ severity: 'success', summary: 'Edited Successfully', detail: editdata, life: 3000 })
    setNeedsEdit(false);
    fetchDataAsync();

  };

  const [deleteConfirmation, setDeleteConfirmation] = useState(false);


  const [delData, setDeleteData] = useState({
    id: '',
  });

  const Delete = (rowData: any) => {
    setDeleteData({
      id: rowData.Id,
    });
    setDeleteConfirmation(true);
  };
  const confirmDelete = async () => {
    const { id } = delData;
    try {
      await dispatch(DeleteData(id) as any);
      toast2.current.show({ severity: 'success', summary: 'Deleted Successfully', detail: deletedata, life: 3000 })
      setDeleteConfirmation(false);
    } catch (error) {
      console.error('Error deleting data:', error);
    }

    fetchDataAsync();

  };
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const validateName = (value: string) => {
    if (!/^[A-Za-z]+$/.test(value)) {
      setErrors((prev) => ({ ...prev, needtype: 'Name must contain only letters' }));
    } else {
      setErrors((prev) => ({ ...prev, needtype: '' }));
    }
    setneedtype(value);
  };
  const isFormValid = needtype && Object.values(errors).every((error) => !error);
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/admin-needtype.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };

  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            {/* <section className="content-header">
              <div className="container-fluid">
                <div className="grid mb-2">
                  <div className="col-9">
                    <h1>Needs</h1>
                  </div>

                  <div className="col-3">
                    <a
                      title="help"
                      onClick={(e) => openWindow(e, IUrl)}
                      style={{

                        color: "blue",
                        fontSize: 15, cursor: "pointer"
                      }}
                    >Help for this Page &nbsp;
                      <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                    </a>
                  </div>
                </div>
              </div>
            </section> */}
            <section className="app-page-header">
              <div>
                <h1 className="app-page-title">Needs</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>
            {/* <section className="content"> */}
            <div className="grid">
              <div className="col-12">
                <div className="card card-primary">
                  {/* <Card title=""> */}
                  <Panel header="">

                    <div className="card card-primary">
                      <div className="card flex flex-wrap justify-content-end">

                        {/* <Button label="Add Needs" severity="info" data-testid="add-needtype-btn" onClick={() => setAddNeeds(true)} /> */}
                        <GFNButton label="Add Needs" buttonType="primary" data-testid="add-needtype-btn" onClick={() => setAddNeeds(true)} />
                      </div>


                      {/* <div className="card flex flex-wrap justify-content">
                            <span className="p-input-icon-left">
                              <i className="pi pi-search" />
                              <InputText value={globalFilter} data-testid="search-input" onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                            </span>
                          </div> */}
                      <div className="card flex flex-wrap justify-content-end my-2">
                        <span className="p-input-icon-left">
                          <i className="pi pi-search ml-2" />

                          <InputText
                            className="app-search-input"
                            value={globalFilter}
                            onChange={(e) => setGlobalFilter(e.target.value)}
                            placeholder="Global Search"
                          />
                        </span>
                      </div>
                      <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                        <Column field="needtype" sortable header="Need Type"></Column>
                        <Column header="Operation" body={(rowData, { rowIndex }) => (
                          <>
                            {/* <Button rounded outlined className='mr-3' data-testid={`edit-btn-${rowIndex}`} tooltip="Edit" icon="pi pi-pencil" onClick={() => Editdata(rowData)} style={{ backgroundColor: 'white', color: 'seagreen' }} />
                                <Button icon="pi pi-trash" tooltip="Delete" data-testid={`delete-btn-${rowIndex}`} onClick={() => Delete(rowData)} rounded outlined className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'red' }} /> */}
                            <GFNButton icon="pi pi-pencil" buttonType="success" size="sm" tooltip="Edit" className='mr-3' testId={`edit-btn${rowIndex}`} onClick={() => Editdata(rowData)} />
                            <GFNButton icon="pi pi-trash" buttonType="danger" size="sm" tooltip="Delete" testId={`delete-btn${rowIndex}`} onClick={() => Delete(rowData)} />
                          </>
                        )} />
                      </DataTable>
                    </div>
                  </Panel>
                  {/* </Card> */}
                </div>

              </div>
            </div>
            <Toast ref={toast} />
            <Toast ref={toast1} />
            <Toast ref={toast2} />
            {/* </section> */}
          </div>
          <Dialog header="Add Needs" breakpoints={{ '960px': '75vw', '641px': '100vw' }} data-testid="add-needtype-dialog" visible={Needsadd} style={{ width: '30vw' }} onHide={() => setAddNeeds(false)} >
            <div className="border d-flex align-items-center justify-content-center">
              <div className="card">
                <div className='grid'>
                  <div className="grid pt-3">
                    <div className="col-8">
                      <label htmlFor="name" className="col-sm-2 control-label font-bold">Need Type:</label>
                    </div>
                    <div className="col-7" >
                      {/* <InputText id="name" style={{ width: '25vw' }} name="needtype" onChange={(e) => setneedtype(e.target.value)} /> */}
                      <InputText id="name" style={{ width: '25vw' }} name="needtype" placeholder='Enter Needtype' data-testid="needtype-input" onChange={(e) => validateName(e.target.value)} />
                    </div>
                  </div>
                </div>
                {/* <Button label="Close" className='mr-6' onClick={AddNeedsclose} data-testid="add-dailog-close-btn" severity="secondary" />
                <Button label="Add" onClick={AddNeeds} disabled={!isFormValid} data-testid="add-dailog-add-btn" style={{ float: 'right' }} /> */}
                <div className="flex justify-content-end gap-2 mt-4">
                  <GFNButton label="Close" onClick={AddNeedsclose} data-testid="add-dailog-close-btn" buttonType="secondary" />
                  <GFNButton label="Add" onClick={AddNeeds} disabled={!isFormValid} data-testid="add-dailog-add-btn" buttonType="primary" />
                </div>
              </div>
            </div>
          </Dialog>
          <Dialog
            header="Edit Need"
            breakpoints={{
              '960px': '75vw',
              '641px': '100vw'
            }}
            data-testid="edit-needtype-dialog"
            visible={Needsedit}
            style={{ width: '30vw' }}
            onHide={() => setNeedsEdit(false)}
            className="border-round-2xl"
          >
            <div className="p-3">
              <div className="field mb-4">
                <label
                  htmlFor="name"
                  className="block text-900 font-semibold mb-2"
                >
                  Need Type
                </label>
                <InputText
                  id="name"
                  name="cname"
                  data-testid="edit-needtype-input"
                  className="w-full"
                  value={editData.needtype}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      needtype: e.target.value
                    })
                  }
                />
              </div>
              {/* Buttons */}
              <div className="flex justify-content-end gap-2 mt-4">
                {/* <Button
                  label="Close"
                  icon="pi pi-times"
                  severity="secondary"
                  outlined
                  onClick={() => setNeedsEdit(false)}
                  data-testid="edit-dialog-close-btn"
                />
                <Button
                  label="Update"
                  icon="pi pi-check"
                  severity="info"
                  onClick={EditAdminNeeds}
                  data-testid="edit-dailog-update-btn"
                /> */}
                <GFNButton label="Close"
                  icon="pi pi-times"
                  buttonType="secondary"
                  outlined
                  onClick={() => setNeedsEdit(false)}
                  testId="edit-dialog-close-btn"
                />
                <GFNButton
                  label="Update"
                  icon="pi pi-check"
                  buttonType="success"
                  onClick={EditAdminNeeds}
                  testId="edit-dailog-update-btn"
                />
              </div>
            </div>
          </Dialog>
          <Dialog header="Confirm Delete" style={{ width: '30vw' }} data-testid="delete-needtype-dialog" visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
            <div>Are you sure you want to delete this item?</div>
            {/* <Button label="Yes" icon="pi pi-check" className='mr-3 p-button-raised' data-testid="delete-dailog-yes-btn" onClick={confirmDelete} />
            <Button label="No" icon="pi pi-times" onClick={AddNeedsclose} className="mr-3 p-button-secondary" data-testid="delete-dailog-no-btn" /> */}
            <div className="flex justify-content-end gap-2 mt-4">
              <GFNButton label="No" icon="pi pi-times" buttonType="secondary" onClick={AddNeedsclose} data-testid="delete-dailog-no-btn" />
              <GFNButton label="Yes" icon="pi pi-check" buttonType="danger" data-testid="delete-dailog-yes-btn" onClick={confirmDelete} />
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  )
}
export default AdminNeeds

